import { Dropdown } from "@ui/Dropdown";
import { Icon } from "@ui/Icon";
import askGVTLogoSmall from "@ui/icons/AskGVTLogoSmall.svg?raw";
import gvtStudioLogoSmall from "@ui/icons/GVTStudioLogoSmall.svg?raw";
import { useLayoutAppKind } from "@ui/layouts/layoutProvider";
import { MaterialSymbol } from "@ui/MaterialSymbol";
import type { JSX } from "solid-js";
import { Show } from "solid-js";
import "./PlatformPickerDropdown.css";
import { pickerHref } from "./pickerMode";

type Props = {
	wordmark: string;
	mark: string;
	expanded: boolean;
};

export const PlatformPickerDropdown = (props: Props) => {
	const appKind = useLayoutAppKind();
	const isStudio = () => appKind === "studio";

	return (
		<Dropdown
			class="platform-picker"
			placement="bottom start"
			triggerVariant="none"
			aria-label="Switch product"
			listBoxStyle={{
				width: "18rem",
				padding: "0.375rem",
			}}
			trigger={
				<span class="platform-picker__trigger">
					<Show
						when={props.expanded}
						fallback={
							<Icon
								icon={props.mark}
								fillWithCurrentColor={false}
								class="platform-picker__mark"
								display="inline-flex"
							/>
						}
					>
						<span class="brand-logo" innerHTML={props.wordmark} />
						<MaterialSymbol
							symbol="keyboard_arrow_down"
							class="platform-picker__chevron"
						/>
					</Show>
				</span>
			}
			content={() => (
				<div class="platform-picker__list">
					<ProductOption
						href={pickerHref("/", "slack")}
						mark={askGVTLogoSmall}
						label="AskGVT"
						description="Ask anyone"
						current={!isStudio()}
					/>
					<ProductOption
						href={pickerHref("/studio", "slack")}
						mark={gvtStudioLogoSmall}
						label="Creator studio"
						description="Upload and ask your videos"
						current={isStudio()}
					/>
				</div>
			)}
		/>
	);
};

const ProductOption = (props: {
	href: string;
	mark: string;
	label: string;
	description: string;
	current: boolean;
}): JSX.Element => (
	<a
		class="platform-picker__option"
		classList={{ "platform-picker__option--current": props.current }}
		href={props.href}
	>
		<Icon
			icon={props.mark}
			fillWithCurrentColor={false}
			class="platform-picker__option-mark"
			display="inline-flex"
		/>
		<span class="platform-picker__option-copy">
			<span class="platform-picker__option-label">{props.label}</span>
			<span class="platform-picker__option-description">{props.description}</span>
		</span>
		<Show when={props.current}>
			<MaterialSymbol symbol="check" class="platform-picker__check" />
		</Show>
	</a>
);
